import { module } from 'modujs'
import { gsap } from "gsap/all"

export default class extends module {
    constructor(m) {
        super(m)

        // UI
        this.$container = this.$('container')[0]
        this.$list = this.$('list')[0]
        this.$items = this.$('item')
        this.$filters = this.$('filter')

        // Events
        this.events = {
            click: {
                filter: 'onFilterClick',
                sort: 'onSortClick'
            }
        }
    }

    ///////////////
    // Lifecycle
    ///////////////
    init() {
        // Scroll to anchor
        const anchor = window.location.hash.replace('#', '')

        // Get the category parameter from the URL
        const urlParams = new URLSearchParams(window.location.search);
        const category = urlParams.get('category');

        if (anchor === 'jobs-listing') {
            if(category) {
                this.handleListUpdate(category)
            } else {
                this.call('scrollTo', { target: this.el, options: { immediate: true, offset: -100 } }, 'Scroll');
            }
        }
    }

    destroy() {
        super.destroy()
    }

    ///////////////
    // Callbacks
    ///////////////
    onFilterClick(e) {
        const $target = e.curTarget
        const id = $target.dataset.category

        // Error
        if (id == null) {
            console.warn('Error: no category id provided')
            return
        }

        // Scroll to list
        // this.call('scrollTo', { target: this.$list, options: { duration: 1, offset: -120 } }, 'Scroll')

        // Update filters
        this.computeActiveFilter($target)

        // update list
        this.handleListUpdate(id)
    }

    onSortClick(e) {
        const $target = e.curTarget
        const slug = $target.dataset.slug

        // Error
        if (slug == null) {
            console.warn('Error: no slug provided')
            return
        }

        // Get current order
        const currentOrder = parseInt($target.dataset.order)

        // Compute new order
        const newOrder = currentOrder == 0 ? 1 : -1 * currentOrder

        // Sort items
        this.sortItems(slug, newOrder)

        // Update order attribute
        $target.dataset.order = newOrder
    }

    ///////////////
    // Methods
    ///////////////
    computeActiveFilter($target) {
        // Get active filter
        const $activeFilter = Array.from(this.$filters).find($filter => $filter.classList.contains('is-active'))

        // Compute classes
        $activeFilter.classList.remove('is-active')
        $target.classList.add('is-active')
    }

    hideList() {
        this.$container.classList.add('is-loading')
    }

    showList() {
        this.$container.classList.remove('is-loading')
    }

    filterItems(id) {
        return new Promise((resolve, reject) => {
            gsap.delayedCall(1, () => {

                let index = 0
                this.$items.forEach(($item) => {
                    if (id == 'all' || $item.dataset.category == id) {
                        $item.classList.remove('is-hidden')
                    } else {
                        $item.classList.add('is-hidden')
                    }
                })

                resolve()
            })
        })
    }

    sortItems(slug, order) {
        const sortedItems = Array.from(this.$items).sort((a, b) => {

            if (a.dataset[slug] < b.dataset[slug]) {
                return order * -1
            } else if (a.dataset[slug] > b.dataset[slug]) {
                return order
            }

            return 0
        })

        // Append sorted items to list
        for (let item of sortedItems) {
            this.$list.appendChild(item)
        }
    }

    async handleListUpdate(id) {
        this.call('scrollTo', { target: this.el, options: { duration: 1, offset: -120 } }, 'Scroll');

        this.hideList()
        await this.filterItems(id)
        this.showList()

        const url = new URL(window.location.href);
        url.hash = 'jobs-listing';
        url.searchParams.set('category', id);

        window.history.replaceState({}, '', url);
    }
}
